<template>
  <history-stack
    :default-view-component="() => import('./GeozoneCard.vue')"
    v-bind="$attrs"
    @stack:close="handleClose"
  />
</template>

<script>
export default {
  name: 'GeozoneHistoryStack',
  setup(props, { root }) {
    const handleClose = () => {
      root.$router.push({
        name: 'geozones'
      });
    };
    return {
      handleClose
    };
  }
};
</script>
